import { render } from "./BoisDAllumage.vue?vue&type=template&id=6a4f1d0b"
import script from "./BoisDAllumage.vue?vue&type=script&lang=js"
export * from "./BoisDAllumage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__